function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import React from 'react';
import Downshift from 'downshift';
export default function createDropdown(ContainerComponent, ListComponent, ButtonComponent, ItemComponent) {
  var Dropdown =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown(props) {
      var _this;

      _classCallCheck(this, Dropdown);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
      _this.state = {
        value: _this.props.defaultValue || _this.props.options[0]
      };
      return _this;
    }

    _createClass(Dropdown, [{
      key: "isControlled",
      value: function isControlled() {
        return this.props.value !== undefined;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var value = this.isControlled() ? this.props.value : this.state.value;
        var initialSelectedItem = value ? this.props.options.find(function (item) {
          return item.value === value.value;
        }) : null;
        return React.createElement(Downshift, {
          initialSelectedItem: initialSelectedItem,
          itemToString: function itemToString(item) {
            return item ? item.label : null;
          },
          onChange: function onChange(item) {
            if (!_this2.isControlled()) {
              _this2.setState({
                value: item
              });
            }

            if (_this2.props.onChange) {
              _this2.props.onChange(item);
            }
          }
        }, function (_ref) {
          var getRootProps = _ref.getRootProps,
              getToggleButtonProps = _ref.getToggleButtonProps,
              getMenuProps = _ref.getMenuProps,
              getItemProps = _ref.getItemProps,
              isOpen = _ref.isOpen,
              highlightedIndex = _ref.highlightedIndex,
              setHighlightedIndex = _ref.setHighlightedIndex,
              selectedItem = _ref.selectedItem;
          return React.createElement(ContainerComponent, _extends({}, getRootProps(), {
            className: _this2.props.className,
            "aria-invalid": _this2.props['aria-invalid']
          }), React.createElement(ButtonComponent, _extends({
            id: _this2.props.id,
            disabled: _this2.props.disabled,
            option: value
          }, getToggleButtonProps())), React.createElement(ListComponent, _extends({
            hidden: !isOpen
          }, getMenuProps(), {
            onMouseLeave: function onMouseLeave() {
              return setHighlightedIndex(-1);
            }
          }), _this2.props.options.map(function (item, index) {
            return React.createElement(ItemComponent, _extends({
              "item-selected": item && selectedItem ? item.value === selectedItem.value ? 'true' : 'false' : 'false',
              "item-highlighted": index === highlightedIndex ? 'true' : 'false'
            }, getItemProps({
              item: item,
              key: item.value
            }), {
              key: item.value,
              option: item
            }));
          })));
        });
      }
    }]);

    return Dropdown;
  }(React.Component);

  return Dropdown;
}